import React from 'react'
import PropTypes from 'prop-types'
import STRINGS from 'utils/strings'
import { REVIEW_TYPES } from '../../MetadataBuilder/constants/metaBuilderConstants'
import { convertMinToDays, formatMinutesAsDuration } from 'utils/time'
import { normalizeSchedules } from '../utils/schedulePreviewHelpers'

const ReviewScreenSettingsPreview = ({ instrument, confirmedSchedules }) => {
  const schedules = [
    ...normalizeSchedules(instrument?.metadata?.schedule),
    ...normalizeSchedules(confirmedSchedules),
  ]
  const schedule =
    schedules.find(item => item?.timeout_window?.review != null || item?.timeout_window?.edit != null) ||
    schedules[0] ||
    {}
  const { timeout_window } = schedule
  const { review, edit } = timeout_window || {}
  const { value: reviewValue, type: reviewType } = review || {}
  const { value: editValue } = edit || {}

  if (!review) {
    return (
      <div className='review-screen-settings-preview'>
        <p>
          <span>{STRINGS.allowReviewQuestion1}</span>
        </p>
        <p>{STRINGS.allowReviewOption2}</p>
      </div>
    )
  }

  const reviewDays = reviewValue ? convertMinToDays(reviewValue, false) : null
  const isAllEntries = reviewType === REVIEW_TYPES.all

  return (
    <div className='review-screen-settings-preview'>
      <p>
        <span>{STRINGS.allowReviewQuestion1}</span>
      </p>
      <p>{STRINGS.allowReviewOption1}</p>
      {review && reviewValue !== undefined && (
        <>
          <p>
            <span>{STRINGS.allowReviewQuestion2}</span>
          </p>
          {isAllEntries ? (
            <p>{STRINGS.allowReviewAll}</p>
          ) : (
            <p>
              {STRINGS.allowReviewPartial} {reviewDays} {reviewDays === 1 ? 'day' : 'days'}
            </p>
          )}
          {editValue !== undefined && (
            <>
              <p>
                <span>{STRINGS.allowEditQuestion}</span>
              </p>
              {isNaN(editValue) ? (
                <p>{STRINGS.allowEditOption2}</p>
              ) : (
                (() => {
                  const formatted = formatMinutesAsDuration(editValue)
                  return (
                    <p>
                      {STRINGS.allowEditOption1} {formatted}
                    </p>
                  )
                })()
              )}
            </>
          )}
        </>
      )}
    </div>
  )
}

ReviewScreenSettingsPreview.propTypes = {
  confirmedSchedules: PropTypes.arrayOf(PropTypes.object),
  instrument: PropTypes.shape({
    metadata: PropTypes.shape({
      schedule: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    }),
  }),
}

export default ReviewScreenSettingsPreview
